import React from 'react';
import { Guest, TABLES } from './seatingTypes';
import PrintSeat from './PrintSeat';

interface PrintRegularTableProps {
  tableKey: string;
  assignments: Map<string, Guest>;
  catererIndex: Map<number, number>;
}

const SEATS_PER_SIDE = 16;

const PrintRegularTable: React.FC<PrintRegularTableProps> = ({ tableKey, assignments, catererIndex }) => {
  const table = TABLES[tableKey as keyof typeof TABLES];
  if (table.type !== 'regular') return null;

  return (
    <div className="table regular-table">
      <h4>{table.name}</h4>
      <div className="table-layout vertical">
        <div className="table-end top">
          <PrintSeat
            guest={assignments.get(`${tableKey}-0`)}
            seatIndex={0}
            seatType="end"
            catererIndex={catererIndex}
          />
        </div>
        <div className="table-sides">
          <div className="table-side left">
            {Array.from({ length: SEATS_PER_SIDE }, (_, i) => (
              <PrintSeat
                key={i + 1}
                guest={assignments.get(`${tableKey}-${i + 1}`)}
                seatIndex={i + 1}
                seatType="left"
                catererIndex={catererIndex}
              />
            ))}
          </div>
          <div className="table-side right">
            {Array.from({ length: SEATS_PER_SIDE }, (_, i) => (
              <PrintSeat
                key={i + 1 + SEATS_PER_SIDE}
                guest={assignments.get(`${tableKey}-${i + 1 + SEATS_PER_SIDE}`)}
                seatIndex={i + 1 + SEATS_PER_SIDE}
                seatType="right"
                catererIndex={catererIndex}
              />
            ))}
          </div>
        </div>
        <div className="table-end bottom">
          <PrintSeat
            guest={assignments.get(`${tableKey}-${SEATS_PER_SIDE * 2 + 1}`)}
            seatIndex={SEATS_PER_SIDE * 2 + 1}
            seatType="end"
            catererIndex={catererIndex}
          />
        </div>
      </div>
    </div>
  );
};

export default PrintRegularTable;
